export const REVIEW_DECISION_OPTIONS = [
  { value: 'CANDIDATE', label: 'Candidate for Custodian' },
  { value: 'REPOSITORY_ONLY', label: 'Repository only' },
  { value: 'RETURN', label: 'Return' },
  { value: 'BLOCK', label: 'Block' },
];

export const TASK_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'UNASSIGNED', label: 'Unassigned' },
  { value: 'ASSIGNED', label: 'Assigned' },
  { value: 'IN_REVIEW', label: 'In review' },
  { value: 'ROUTED', label: 'Routed' },
  { value: 'COMPLETED', label: 'Completed' },
];

export const RECOMMENDATION_FILTER_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'CANDIDATE', label: 'Candidate for Custodian' },
  { value: 'REPOSITORY_ONLY', label: 'Repository only' },
  { value: 'RETURN', label: 'Return' },
];

export function recommendationLabel(recommendation) {
  if (!recommendation) return 'None';
  const match = REVIEW_DECISION_OPTIONS.find((option) => option.value === recommendation);
  return match ? match.label : recommendation;
}

export function taskStatusLabel(status) {
  if (!status) return '—';
  const match = TASK_STATUS_OPTIONS.find((option) => option.value === status);
  return match ? match.label : status;
}

export function authorityStateLabel(state) {
  if (!state) return '—';
  if (state === 'PENDING') return 'PENDING';
  return state;
}

export function nextHandlerLabel(row) {
  if (!row) return 'Provider';
  if (row.task_status === 'ROUTED') return 'Routed to Custodian';
  if (row.recommendation === 'CANDIDATE') return 'Ready to route';
  if (row.recommendation === 'REPOSITORY_ONLY') return 'No custodian';
  if (row.recommendation === 'RETURN') return 'Returned';
  if (row.recommendation === 'BLOCK') return 'Blocked';
  if (row.task_status === 'UNASSIGNED') return 'Provider';
  return 'Provider';
}

export function canRouteToCustodian(row) {
  return (
    Boolean(row?.task_id) &&
    row?.recommendation === 'CANDIDATE' &&
    row?.task_status !== 'ROUTED'
  );
}

export function providerDecisionOutcome(decision, authorityState) {
  if (decision === 'CANDIDATE') {
    return {
      title: 'Candidate for Custodian review',
      detail: `Provider eligibility only. Authority state remains ${authorityState || 'PENDING'}.`,
    };
  }
  if (decision === 'REPOSITORY_ONLY') {
    return {
      title: 'Repository only',
      detail: 'Provider eligibility outcome. This is not legal authority approval and is not routed to Custodian.',
    };
  }
  if (decision === 'RETURN') {
    return {
      title: 'Returned',
      detail: 'Provider outcome. This asset was not routed to Custodian.',
    };
  }
  if (decision === 'BLOCK') {
    return {
      title: 'Blocked',
      detail: 'Provider outcome. Legal authority was not approved or rejected.',
    };
  }
  return {
    title: recommendationLabel(decision),
    detail: `Authority state remains ${authorityState || 'PENDING'}.`,
  };
}

export function nextActionLabel(nextAction) {
  if (nextAction === 'AWAITING_CUSTODIAN') return 'Routed to Custodian';
  if (nextAction === 'READY_TO_ROUTE') return 'Ready to route to Custodian';
  if (nextAction === 'AWAITING_PROVIDER_REVIEW') return 'Awaiting Provider review';
  if (nextAction === 'AWAITING_ADMISSION') return 'Awaiting admission';
  if (nextAction === 'READY_TO_ADMIT') return 'Awaiting Custodian (authority already decided)';
  if (nextAction === 'VIEW') return 'View only';
  return nextAction || '—';
}

export function recommendationClass(recommendation) {
  if (recommendation === 'CANDIDATE') return 'font-medium text-evault-teal-deep';
  if (recommendation === 'RETURN') return 'font-medium text-evault-gold';
  if (recommendation === 'REPOSITORY_ONLY') return 'text-umb-neutral-dark/55';
  if (recommendation === 'BLOCK') return 'font-semibold text-red-600';
  return 'text-umb-neutral-dark/85';
}

export function authorityClass(state) {
  if (state === 'PENDING') return 'font-medium text-evault-gold';
  if (state === 'APPROVED') return 'font-medium text-evault-vault-active';
  if (state === 'REJECTED') return 'font-semibold text-red-600';
  return 'text-umb-neutral-dark/85';
}

export function candidateDetailPath(assetId, taskId) {
  const path = `/provider/authority-review/${assetId}`;
  return taskId ? `${path}?task=${encodeURIComponent(taskId)}` : path;
}

export const PACKAGE_STATUS_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'SUBMITTED', label: 'Submitted' },
  { value: 'CLASSIFIED', label: 'Classified' },
  { value: 'CERTIFIED', label: 'Certified' },
];

export function packageStatusLabel(status) {
  if (!status) return '—';
  const match = PACKAGE_STATUS_OPTIONS.find((option) => option.value === status);
  return match ? match.label : status;
}

export function packageStatusClass(status) {
  if (status === 'CERTIFIED') return 'font-medium text-evault-vault-active';
  if (status === 'CLASSIFIED' || status === 'SUBMITTED') return 'font-medium text-evault-teal-deep';
  return 'text-umb-neutral-dark/70';
}

export function batchDisplayId(row) {
  return row?.reference_number || row?.batch_id || '—';
}
